import { RoleService } from "@js/services/RoleService";
import { ListItem, SelectListService } from "@js/services/SelectListService";
import {
  AppPackagePricing,
  ApplicationUser,
  InvitedBrokerDTO,
  LinkTypeEnum,
  Organisation,
  OrganisationClient,
  OrganisationLink,
  OrganisationTypeEnum,
  PaymentClient,
  UserClient,
  StaticDataClient,
  FileAttachmentClient,
  OrganisationLinkClient,
  OrganisationCrudClient,
  OrganisationUpdate,
  ClaimClient,
  ClaimGroupsInApplicationUser,
  ClaimGroup,
  LinkSourceTypeEnum,
  CRMEnum
} from "@src/apis/ModularClient";

import angular from "angular";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { AuthService } from "@js/services/AuthService";
import { OrganisationService } from "@js/services/OrganisationService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class OrganisationsController {
  organisationsMinimal: { name?: string; id: number; uniqueRef?: string }[];
  selectedOrganisation: OrganisationUpdate;
  originalOrganisation: OrganisationUpdate;
  totalCount: number;

  //invite users
  newUser: InvitedBrokerDTO;
  users: InvitedBrokerDTO[] = [];
  showModal: boolean = false;

  //rename Email
  renamingItem: InvitedBrokerDTO;
  newName: InvitedBrokerDTO = {
    email: null,
    firstName: null,
  };
  tempdata: InvitedBrokerDTO;
  //Brokers
  organisationAdminId?: number = null;
  organisationAdmin: ApplicationUser;
  organisationUsers: ApplicationUser[];
  organisationUsersExceptAdmin: ApplicationUser[];
  licensedOrganisationUsers: ApplicationUser[];
  organisationAdminGroup: ClaimGroup;
  organisationAdminGroupId: number;
  selectedOrganisationAdmins: ApplicationUser[];
  // temp storing user while deleteing
  confirmDeleteUser: ApplicationUser;

  uniqueLinks: OrganisationLink[];
  selectedUniqueLink: OrganisationLink;

  page: number = 1;
  rolepageid: any;
  userFilter: string = "";
  countperpage: number = 10;

  loadingRoles: boolean;
  error: boolean;
  isInvalidForm: boolean;

  logoURL: string;

  deleteMessage: string;

  deleteConfirmMessage: string;

  registrationForm: ng.IFormController;

  addEmail: ng.IFormController;

  deleteConfirmation: boolean;
  messageDeleteModal: boolean;
  goToUserDashboard: boolean;
  brokerUserDelete: boolean = false;

  //toggle to control the Broker user section
  showBrokerUsers: boolean = false;

  profileEdit: ApplicationUser;
  showEdit: boolean = false;
  isAdmin: boolean;
  newname: string;
  // Show and hide a input field to add users.
  hideInput: boolean = false;
  showErrorMsg: boolean = false;
  errorMsg: string;
  imageErrorMsg: string;

  // Indicates when org is saving
  isProcessingOrgSave: boolean = false;

  // Indicates when invites are being sent
  isProcessingInvites: boolean = false;

  // Indicates when saving a broker profile
  isProcessingProfileSave: boolean = false;

  orgFilter: string = "";

  allActiveAppPackagePrices: AppPackagePricing[];
  selectedProductList: AppPackagePricing[] = [];
  licenseEndDate: Date;
  quantity = 1;

  buttonColor: string = "#304b9a";
  message: string;
  messageTitle: string;
  widgetModal: boolean = false;
  showLeadGenLicenseActive: boolean = false;
  leadGeneratorName: string;

  teamSizeOptions = [];
  linkTypeOptions = [];

  isAddonSelected: boolean = false;
  licenseStatusText: string;
  whiteLabelledUrl: string = "";

  showTestEmailModal: boolean = false;
  showTestEmailSentConfirmation: boolean = false;
  testEmails: string;
  testEmailBody: string = "This is a test email.";
  testEmailSubject: string = "Test email";
  isValidOrgCode: boolean = true;
  validateCodeClicked: boolean = false;
  fetchingUniqueLinks: boolean = false;
  displayMessage: string = "";
  deleteUniqueLinkClicked: boolean = false;
  confirmUniqueLinkDeletion: boolean = false;
  isEditUniqueLink: boolean = false;
  showEditUniqueLinkModal: boolean = false;
  editLogo: boolean = false;
  isSavingUniqueLink: boolean = false;
  ulsavemessage: string = "";

  organisation: Organisation;
  orgCode: string = "";
  orgLogo: string = "";

  //Preview a registration page
  previewContent: boolean = true;
  showPreview: boolean = false;

  hubspotMessage: string;
  isHubspotValid: boolean = false;
  missingProperties: string[];

  locationOptions = [];
  organisationThemeColour: string;

  // Dropdown to select widget/ enterprise
  showDevFinanaceLinkOptions: boolean = false;
  showAllLoansLinkOptions: boolean = false;
  showBridgingLinkOptions: boolean = false;
  showCommercialLinkOptions: boolean = false;

  showLinkOptions: boolean[];

  connectNetworkOrgId: number;
  crms = this.selectListService.GetCRMs();
  brokerNetworks = this.selectListService.GetBrokerNetworks();
  selectedCRMs: ListItem[];
  selectedBrokerNetworks: ListItem[];
  showMarkAsConnectConfirmationModal: boolean = false;
  isMarkAsConnectConfirmed: boolean = false;

  linkTypeSelection: {} = [];
  LinkTypeEnum: LinkSourceTypeEnum;
  accountManagersOptions: string[] = [];
  subscriptionTypeOptions = [];

  static $inject = [
    "$scope",
    "$rootScope",
    "$cookies",
    "$location",
    "$http",
    "RoleService",
    "FileAttachmentHelper",
    "FileAttachmentClient",
    "PaymentClient",
    "UserClient",
    "$window",
    "SelectListService",
    "OrganisationClient",
    "OrganisationCrudClient",
    "AuthService",
    "StaticDataClient",
    "OrganisationLinkClient",
    "OrganisationService",
    "ODataHelper",
    "ClaimClient",
    "$q",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private $role: RoleService,
    private fileAttachmentHelper: FileAttachmentHelper,
    private fileAttachmentClient: FileAttachmentClient,
    private paymentClient: PaymentClient,
    private userClient: UserClient,
    private $window: ng.IWindowService,
    private selectListService: SelectListService,
    private organisationClient: OrganisationClient,
    private organisationCrudClient: OrganisationCrudClient,
    private authService: AuthService,
    private staticDataClient: StaticDataClient,
    private organisationLinkClient: OrganisationLinkClient,
    private $organisationService: OrganisationService,
    private odataHelper: ODataHelper,
    private claimClient: ClaimClient,
    private $q: ng.IQService,
  ) {
    this.loadingRoles = true;
    this.deleteConfirmation = false;
    this.messageDeleteModal = false;
    this.isInvalidForm = true;

    if (sessionStorage.getItem("filterText")) {
      this.orgFilter = sessionStorage.getItem("filterText");
      sessionStorage.removeItem("filterText");
    }

    if (sessionStorage.getItem("pageNo")) {
      this.setPage(Number(sessionStorage.getItem("pageNo")));
      sessionStorage.removeItem("pageNo");
    } else {
      this.setPage(1);
    }
    this.checkForAdmin();

    this.leadGeneratorName = this.$cookies.get("leadgeneratorname");
    this.teamSizeOptions = this.selectListService.GetTeamSizeOptions();
    //this.getWhiteLabelledUrl();
    //this.getConnectNetworkOrgId();
    this.getAppSettings();
    this.getOrganisationAdminGroup();
    this.locationOptions = this.selectListService.GetLocations();
    this.subscriptionTypeOptions = this.selectListService.GetBrokerSubscriptionTypeOptions();
  }

  onSelectingOrganisation(orgId: number) {
    this.organisationClient.fetch(orgId).then((response) => {
      this.selectedOrganisation = response;
      this.originalOrganisation = { ...this.selectedOrganisation };
      this.getOrganisationDetail();
      this.fetchUniqueLinks();
      this.initializeSelectedNetworks();
      this.initializeCRMs();
    });
  }

  getLogoURL(url: string) {
    if (url) {
      this.fileAttachmentClient.getAmazonFileAccessUri(url).then((result) => {
        this.selectedOrganisation.logoURL = result;
      });
    }
  }

  changeCompanyLogo(files, logoUrl: number) {
    this.imageErrorMsg = null;
    const allowedExtensions = [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "tif",
      "tiff",
      "ico",
      "jfif",
      "pjpeg",
      "pjp",
      "apng",
    ];
    const filteredFiles = files.filter((file) => {
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      return fileExtension && allowedExtensions.indexOf(fileExtension) !== -1;
    });

    if (filteredFiles.length === 0 && files.length > 0) {
      this.imageErrorMsg = "Invalid file type: SVG and webp formats are not supported";
      return;
    }
    this.fileAttachmentHelper.uploadPublicImage(files, this.selectedOrganisation.organisationCode).then((imageUrl) => {
      if (logoUrl == 1) {
        this.selectedOrganisation.logoURL = imageUrl;
        this.orgLogo = imageUrl;
      } else {
        this.selectedOrganisation.faviconURL = imageUrl;
      }

      this.registrationForm.$setDirty();
    });
  }

  removeCompanyLogo(removeLogoUrl) {
    if (removeLogoUrl) {
      this.selectedOrganisation.logoURL = "";
      this.orgLogo = "";
    } else {
      this.selectedOrganisation.faviconURL = "";
    }
    this.registrationForm.$setDirty();
  }

  setPage(newPage: number): void {
    this.loadingRoles = true;
    this.page = newPage;
    try {
      this.odataHelper
        .getPaginated(this.organisationCrudClient, {
          filter: this.orgFilter ? { name: { contains: this.orgFilter } } : undefined,
          top: this.countperpage,
          skip: this.page ? (this.page - 1) * this.countperpage : undefined,
          select: {
            id: true,
            name: true,
            uniqueRef: true,
          },
          orderBy: ["name"],
        })
        .then(({ value: organisationsMinimal, count: totalCount }) => {
          this.organisationsMinimal = organisationsMinimal;
          this.totalCount = totalCount;

          if (sessionStorage.getItem("selectedOrganisation")) {
            const { id: matchingId } = this.organisationsMinimal.find(
              (organisation) => organisation.uniqueRef === sessionStorage.getItem("selectedOrganisation"),
            );
            this.onSelectingOrganisation(matchingId);
            sessionStorage.removeItem("selectedOrganisation");
          } else if (this.organisationsMinimal.length == 1) {
            this.onSelectingOrganisation(this.organisationsMinimal[0].id);
          }
          this.loadingRoles = false;
        });
    } catch (response) {
      this.error = true;
      this.loadingRoles = false;
    }
  }

  displayItem(item) {
    this.selectedOrganisation = item;
  }

  addUser() {
    var temp = { ...this.newUser };
    this.users.push(temp);
    this.newUser.email = null;
    this.newUser.firstName = null;
    this.addEmail.$setPristine();
  }

  invite() {
    this.isProcessingInvites = true;

    this.organisationClient
      .inviteBrokers(this.selectedOrganisation.uniqueRef, this.users)
      .finally(() => {
        delete this.newUser;
        this.users = [];
        this.hideInput = false;
        this.deleteMessage = "Invitations have been sent.";
        this.messageDeleteModal = true;
      })
      .finally(() => {
        this.isProcessingInvites = false;
      });
  }

  removeEmail(item: InvitedBrokerDTO) {
    this.users = this.users.filter((x) => x != item);
  }

  renameItem(item: InvitedBrokerDTO) {
    if (this.renamingItem === undefined) {
      this.newName = item;
      this.renamingItem = item;
      this.tempdata = { ...this.renamingItem };
    } else {
      delete this.renamingItem;
    }
  }

  cancelRenaming(item: InvitedBrokerDTO) {
    this.users = this.users.filter((x) => x != item);
    this.users.push(this.tempdata);
    delete this.renamingItem;
    this.addEmail.editUserFirstName.$setUntouched();
    this.addEmail.editUserEmail.$setUntouched();
  }

  renamingItemComplete(item: InvitedBrokerDTO) {
    this.users = this.users.filter((x) => x != item);
    this.users.push(this.newName);
    this.renamingItem = null;
  }

  addNewUser() {
    if (this.newUser.email != null && this.newUser.firstName != null) {
      this.addUser();
      this.addEmail.newUserFirstName.$setUntouched();
      this.addEmail.newUserEmail.$setUntouched();
    }
  }

  cancelAddingNewUser() {
    this.newUser.email = null;
    this.newUser.firstName = null;
    this.addEmail.newUserFirstName.$setUntouched();
    this.addEmail.newUserEmail.$setUntouched();
  }

  getFocusToInput() {
    var getelement = this.$window.document.getElementById("newuser");
    getelement.focus();
  }

  removeErrors() {
    delete this.error;
    this.orgCode = this.selectedOrganisation.organisationCode;
  }

  saveOrganisation(): void {
    delete this.error;
    this.isProcessingOrgSave = true;

    if (
      this.selectedOrganisation.isConnectMember &&
      this.originalOrganisation &&
      !this.originalOrganisation.isConnectMember &&
      !this.isMarkAsConnectConfirmed
    ) {
      this.showMarkAsConnectConfirmationModal = true;
      return;
    }

    if (
      this.selectedOrganisation.organisationThemeColour &&
      (this.selectedOrganisation.organisationThemeColour == "#304B9A" ||
        this.selectedOrganisation.organisationThemeColour == "#304b9a")
    ) {
      this.selectedOrganisation.organisationThemeColour = "";
    }

    if (
      this.selectedOrganisation.companyURL != null &&
      this.selectedOrganisation.companyURL.replace(/^https?\:\/\//g, "").length > 0
    ) {
      if (!/^https?:\/\//i.test(this.selectedOrganisation.companyURL)) {
        this.selectedOrganisation.companyURL = `https://${this.selectedOrganisation.companyURL}`;
      }
    }

    if (this.selectedOrganisation.hasWhiteLabelAddOnPaid && this.selectedOrganisation.isWhiteLabelled) {
      if (this.selectedOrganisation.twitterUrl && this.selectedOrganisation.twitterUrl.length > 0) {
        if (!/^https?:\/\//i.test(this.selectedOrganisation.twitterUrl)) {
          this.selectedOrganisation.twitterUrl = `https://${this.selectedOrganisation.twitterUrl}`;
        }
      }
      if (this.selectedOrganisation.facebookUrl && this.selectedOrganisation.facebookUrl.length > 0) {
        if (!/^https?:\/\//i.test(this.selectedOrganisation.facebookUrl)) {
          this.selectedOrganisation.facebookUrl = `https://${this.selectedOrganisation.facebookUrl}`;
        }
      }
      if (this.selectedOrganisation.youTubeUrl && this.selectedOrganisation.youTubeUrl.length > 0) {
        if (!/^https?:\/\//i.test(this.selectedOrganisation.youTubeUrl)) {
          this.selectedOrganisation.youTubeUrl = `https://${this.selectedOrganisation.youTubeUrl}`;
        }
      }
      if (this.selectedOrganisation.linkedInUrl && this.selectedOrganisation.linkedInUrl.length > 0) {
        if (!/^https?:\/\//i.test(this.selectedOrganisation.linkedInUrl)) {
          this.selectedOrganisation.linkedInUrl = `https://${this.selectedOrganisation.linkedInUrl}`;
        }
      }
    }
    /* }*/

    this.saveSelectedCRMs();

    // If CRM does not include "other" then make sure the CRM detail field is empty before saving
    const hasOther = this.hasOtherCrmSelected();
    if (!hasOther && this.selectedOrganisation.crmDetail) {
      this.selectedOrganisation.crmDetail = '';
    }

    this.saveSelectedNetworks();

    const isOrgConvertedToConnectMember =
      this.selectedOrganisation.isConnectMember &&
      this.originalOrganisation &&
      !this.originalOrganisation.isConnectMember;

    this.organisationClient
      .saveOrganisation(this.selectedOrganisation as Organisation, isOrgConvertedToConnectMember)
      .then((response) => {
        if (this.organisationAdminId && this.organisationAdmin?.id != this.organisationAdminId) {
          this.userClient.setBrokerOrgAdmin(this.selectedOrganisation.id, this.organisationAdminId);
        }

        let adminUpdatePromise: ng.IPromise<void> = this.$q.resolve();

        if (this.selectedOrganisationAdmins?.length) {
          adminUpdatePromise = this.updateOrganisationAdminClaims();
        }

        (this.$rootScope as any).formSaved = true;
        let index = this.organisationsMinimal.findIndex((org) => org.id == this.selectedOrganisation.id);
        this.organisationsMinimal.splice(index, 1);
        this.organisationsMinimal.push(this.selectedOrganisation);
        delete this.selectedOrganisation;
        if (this.organisationsMinimal.length == 1) {
          this.onSelectingOrganisation(this.organisationsMinimal[0].id);
        }

        this.registrationForm.$setPristine();
        this.deleteMessage = "Your changes have been saved.";
        this.messageDeleteModal = true;
        this.goToUserDashboard = true; // When the User closes the pop-up box, they will be redirected to the User Dashboard
      })
      .catch((response) => {
        this.error = true;
      })
      .finally(() => {
        this.isProcessingOrgSave = false;
      });
  }

  validateForm() {
    if (this.registrationForm.$invalid) {
      let invalidName;
      angular.forEach(this.registrationForm.$error, function (field) {
        angular.forEach(field, function (errorfield) {
          errorfield.$setTouched();
          invalidName = errorfield.$name;
        });
      });
      let element = this.$window.document.getElementsByName(invalidName)[0] as unknown as HTMLElement;
      element?.scrollIntoView({ behavior: "smooth", block: "center" });
      return true;
    }
    return false;
  }

  deleteOrganisation() {
    this.deleteConfirmation = true;
    this.deleteConfirmMessage = "Are you sure you want to delete the company " + this.selectedOrganisation.name + "?";
  }

  confirmDelete(item: Organisation) {
    delete this.selectedOrganisation;
    this.deleteConfirmation = false;
    this.organisationClient
      .deleteOrganisation(item.id)
      .then((response) => {
        this.deleteMessage = "The company " + item.name + " has been successfully deleted.";
        this.messageDeleteModal = true;
        this.organisationsMinimal = this.organisationsMinimal.filter((organisation) => organisation.id != item.id);
      })
      .catch((response) => {
        this.error = true;
        this.deleteMessage = "Sorry! We had an error deleting the company " + item.name + ". Please, try again later.";
        this.messageDeleteModal = true;
      });
  }

  cancelDelete() {
    this.deleteConfirmation = false;
  }

  closeMessageSuccesfullyDeleted() {
    if (this.goToUserDashboard && this.isAdmin) {
      this.$location.path("/userdashboard"); // redirects User to User Dashboard
      this.goToUserDashboard = false;
    }
    this.messageDeleteModal = false;
  }

  addNewOrganisation() {
    this.selectedOrganisation = {
      name: "",
      organisationType: OrganisationTypeEnum.Broker,
      hasCommercialMortgage: true,
      hasBridging: true,
      isDeleted: false,
      fcaNumber: "",
      companyURL: "",
      facebookUrl: "",
      faviconURL: "",
      footerText: "",
      helpdeskEmail: "",
      hubspotPipelineStage: "",
      linkedInUrl: "",
      logoURL: "",
      organisationCode: "",
      organisationTermForApp: "",
      organisationThemeColour: "",
      phoneNumber: "",
      preferredPackagerEmail: "",
      signOff: "",
      tagLine: "",
      testimonialCustomerDetails: "",
      testimonialText: "",
      twitterUrl: "",
      widgetCompanyURL: "",
      youTubeUrl: "",
      licenseMaster: null,
      testimonialCustomerImageUrl: "",
      applicationUsers: [],
      brokerUsers: [],
      referredUsers: [],
    } as Organisation;

    this.organisationAdminId = null;
    this.organisationAdmin = null;
    this.licensedOrganisationUsers = [];
    this.organisationUsers = [];
    this.selectedOrganisationAdmins = [];
  }

  ormValidation(name: string, type: number) {
    if (!name || !type) {
      this.isInvalidForm = true;
    }

    this.isInvalidForm = false;
  }

  registerDisabled() {
    if (this.selectedOrganisation && this.errorMsg == null && !this.isProcessingOrgSave) {
      return false;
    } else {
      return true;
    }
  }

  getOrganisationDetail(): void {
    this.organisationClient
      .getAllOrganisationMembers(this.selectedOrganisation.id)
      .then((orgBrokers: ApplicationUser[]) => {
        this.organisationUsers = orgBrokers;
        this.organisationAdmin = orgBrokers?.find((x) => x.isOrganisationAdmin);

        this.licensedOrganisationUsers = (this.organisationUsers || []).filter(
          (x) => x.subscriptionStatus > 0 || x.isOrganisationAdmin,
        );

        this.initializeSelectedOrganisationAdmins();

        if (this.organisationAdmin) {
          this.organisationAdminId = this.organisationAdmin.id;
          this.organisationUsersExceptAdmin = this.organisationUsers.filter((x) => x.id != this.organisationAdminId);

          this.getActivePackagePricingsForTrialLicense();
          this.isLeadGenLicenseActive();
        }
      })
      .then(() => {
        if (this.organisationsMinimal.length > 1) this.getLicenseStatusText();
      });

    this.linkTypeOptions = this.selectListService.GetLinkTypeOptions(
      this.selectedOrganisation.hasBridging,
      this.selectedOrganisation.hasCommercialMortgage,
    );
  }

  getOrganisationAdminGroup() {
    this.claimClient.claimGroupsList(false, false, false, true).then((response) => {
      this.organisationAdminGroup = response.find((cg) => cg.name === "OrganisationAdmin");
      this.organisationAdminGroupId = this.organisationAdminGroup.id;
    });
  }

  initializeSelectedOrganisationAdmins() {
    this.selectedOrganisationAdmins = [];

    this.organisationUsers.forEach((user) => {
      (user as any).ticked = false;

      const isAdmin = user.claimGroupsInApplicationUsers?.some(
        (cg) => cg.claimGroupId === this.organisationAdminGroupId,
      );

      if (isAdmin) {
        (user as any).ticked = true;
        this.selectedOrganisationAdmins.push(user);
      }

      if (user.id === this.organisationAdmin?.id) {
        (user as any).isDisabled = true;
      } else {
        (user as any).isDisabled = false;
      }
    });
  }

  saveSelectedOrganisationAdmins(): void {
    this.registrationForm.$setDirty();
  }

  updateOrganisationAdminClaims(): ng.IPromise<void> {
    const selectedAdminIds = this.selectedOrganisationAdmins.map((u) => u.id);

    const existingAdminIds = this.organisationUsers
      .filter(
        (user) => user.claimGroupsInApplicationUsers?.some((cg) => cg.claimGroupId === this.organisationAdminGroup.id),
      )
      .map((u) => u.id);

    const toAdd = selectedAdminIds.filter((id) => !existingAdminIds.includes(id));
    const toRemove = existingAdminIds.filter((id) => !selectedAdminIds.includes(id));

    if (toAdd.length === 0 && toRemove.length === 0) {
      return this.$q.resolve(); // no changes needed
    }

    const promises: ng.IPromise<ClaimGroupsInApplicationUser[]>[] = [];

    if (toAdd.length > 0) {
      promises.push(
        this.claimClient.addRemoveUpdateClaimGroupsToAppUserOrUsers({
          claimGroupSets: toAdd,
          claimGroupsToAddUpdate: [this.organisationAdminGroup],
          claimGroupsToRemove: [],
          removeExistingUnMentionedClaimGroups: false,
        }),
      );
    }

    if (toRemove.length > 0) {
      promises.push(
        this.claimClient.addRemoveUpdateClaimGroupsToAppUserOrUsers({
          claimGroupSets: toRemove,
          claimGroupsToAddUpdate: [],
          claimGroupsToRemove: [this.organisationAdminGroupId],
          removeExistingUnMentionedClaimGroups: false,
        }),
      );
    }

    return this.$q
      .all(promises)
      .then(() => { })
      .catch((error) => {
        this.error = true;
      });
  }

  onOrganisationAdminChange(): void {
    this.organisationUsers.forEach((user) => {
      (user as any).isDisabled = user.id === this.organisationAdminId;
    });

    const adminUser = this.organisationUsers.find((user) => user.id === this.organisationAdminId);

    if (adminUser) {
      const alreadySelected = this.selectedOrganisationAdmins.some((user) => user.id === adminUser.id);

      if (!alreadySelected) {
        this.selectedOrganisationAdmins.push(adminUser);
        (adminUser as any).ticked = true;
      }
    }
  }

  isLeadGenLicenseActive(): void {
    this.organisationClient.isLeadGenLicenseActive(this.selectedOrganisation.id).then((response) => {
      this.showLeadGenLicenseActive = response;
    });
  }

  deleteBrokerUser(user: ApplicationUser) {
    this.deleteConfirmation = true;
    this.brokerUserDelete = true;
    this.deleteConfirmMessage =
      "Are you sure you want to delete the Broker User" + user.firstName + " " + user.lastName + "?";
    this.confirmDeleteUser = { ...user };
  }

  confirmBrokerDelete(item: ApplicationUser) {
    this.deleteConfirmation = false;
    this.userClient
      .deleteUserAndPermissions(item.userName)
      .then((response) => {
        this.deleteMessage = "Your Broker" + item.firstName + item.lastName + " was successfully deleted!";
        this.messageDeleteModal = true;
        this.organisationUsersExceptAdmin = this.organisationUsersExceptAdmin.filter((user) => user != item);
      })
      .catch((response) => {
        this.error = true;
        this.deleteMessage =
          "Sorry! We had an error deleting the broker user " +
          item.firstName +
          " " +
          item.lastName +
          ". Please, try again later.";
        this.messageDeleteModal = true;
      });
  }

  cancelBrokerDelete() {
    this.deleteConfirmation = false;
    this.brokerUserDelete = false;
  }

  updateBrokerUser(user: ApplicationUser): void {
    this.profileEdit = user;
    this.showEdit = true;
  }

  /** Save the user changes */
  saveProfile() {
    this.isProcessingProfileSave = true;
    this.showEdit = false;
    this.userClient
      .processUserRegistrationAndUpdate(this.profileEdit.id, false)
      .then((userResponse) => {
        this.deleteMessage =
          this.profileEdit.firstName + " " + this.profileEdit.lastName + "'s details have been saved";
        this.messageDeleteModal = true;
      })
      .finally(() => {
        this.isProcessingProfileSave = false;
      });
  }

  closeEditModal() {
    this.showEdit = false;
    this.profileEdit = null;
  }

  checkForAdmin(): void {
    this.$role.isAdminUser().then((response) => {
      this.isAdmin = response;
    });
  }

  isHtml(input) {
    let isHtml;
    this.errorMsg = null;
    isHtml = /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(input);
    if (isHtml) {
      this.errorMsg = "Please remove any special characters from footer text.";
    }
  }

  removeNewUserEmail() {
    this.newUser.email = "";
  }

  go(path: string) {
    this.$location.path(path);
  }

  goToSettingPage() {
    sessionStorage.setItem("selectedOrganisation", this.selectedOrganisation.uniqueRef);
    if (this.orgFilter.length > 0) sessionStorage.setItem("filterText", this.orgFilter);
    if (this.page > 1) sessionStorage.setItem("pageNo", this.page.toString());
    this.go(`/settings/${this.organisationAdmin.id}`);
  }

  getActivePackagePricingsForTrialLicense() {
    this.allActiveAppPackagePrices = [];
    this.paymentClient.getActivePackagePricingsForTrialLicense(this.organisationAdmin.userName).then((response) => {
      this.allActiveAppPackagePrices = response;
    });
  }

  onChangingPackage(selectedPackage) {
    if (this.selectedProductList != null && this.selectedProductList.length > 0) {
      var found = this.selectedProductList.find(function (product) {
        return product.id == selectedPackage.Id;
      });

      if (found) {
        this.selectedProductList = this.selectedProductList.filter(function (e) {
          return e.id != selectedPackage.Id;
        });
      } else {
        this.selectedProductList.push(selectedPackage);
      }
    } else {
      this.selectedProductList.push(selectedPackage);
    }
  }

  assignLicenseToOrganisation() {
    this.organisationClient
      .assignTrialLicenseToOrg(
        this.licenseEndDate,
        this.organisationAdmin.id,
        this.selectedProductList,
        this.quantity,
        true,
        this.isAddonSelected,
      )
      .then((response) => {
        if (response) {
          this.deleteMessage = `Trial license has been assigned to ${this.organisationAdmin.fullName}`;
          this.messageDeleteModal = true;
          this.allActiveAppPackagePrices = [];
          this.selectedOrganisation.hasWhiteLabelAddOnPaid = this.isAddonSelected;
        } else {
          this.deleteMessage = `Problem while assigning trial license, please try after some time.`;
          this.messageDeleteModal = true;
        }
      });
  }

  generateButtonCode() {
    if (this.selectedOrganisation.organisationCode) {
      //var style = `background-color:${this.buttonColor};border-radius: 4px; padding: 0.5rem 1rem;cursor: pointer;outline: none;line-height: 1.3rem;`
      //this.message = `<button  style="${style}" id="brickflowEmbed">Search Loan</button><script src="${location.origin}/embed.js" id='brickflowEmbedScript' url="${location.origin}/${this.selectedOrganisation.organisationCode}#!/initialregister/borrower/"></script>`;
      this.message = `${this.whiteLabelledUrl}${this.selectedOrganisation.organisationCode}#!/e/devfinancecriteria`;
      this.messageTitle = "Please copy the below URL to include in your website.";
      this.widgetModal = true;
    } else if (this.selectedOrganisation.isBrickflow) {
      this.message = `${this.whiteLabelledUrl}#!/e/devfinancecriteria`;
      this.messageTitle = "Please copy the below URL to include in your website.";
      this.widgetModal = true;
    } else {
      this.deleteMessage =
        "To access your " +
        this.leadGeneratorName +
        " URL please ensure you have an active White Label add-on and you have completed the URL Company Code in your company settings (under White Label)";
      this.messageDeleteModal = true;
    }
  }

  // generateAllLoansUrl(id: number = null): string {
  //   var url = "";

  //   if (this.selectedOrganisation.organisationCode) {
  //     url = `${this.whiteLabelledUrl}${this.selectedOrganisation.organisationCode}#!/allloans`;
  //   } else if (this.selectedOrganisation.isBrickflow) {
  //     url = `${this.whiteLabelledUrl}#!/allloans`;
  //   }

  //   if (id != null) {
  //     url += `/${id}`;
  //   }

  //   return url;
  // }

  // generateBridgingCriteriaURL(): string {
  //   if (this.selectedOrganisation.organisationCode) {
  //     return `${this.whiteLabelledUrl}${this.selectedOrganisation.organisationCode}#!/e/bridgingcriteria`;
  //   } else if (this.selectedOrganisation.isBrickflow) {
  //     return `${this.whiteLabelledUrl}#!/e/bridgingcriteria`;
  //   }
  // }

  // generateCommercialCriteriaURL(): string {
  //   if (this.selectedOrganisation.organisationCode) {
  //     return `${this.whiteLabelledUrl}${this.selectedOrganisation.organisationCode}#!/e/commercialcriteria`;
  //   } else if (this.selectedOrganisation.isBrickflow) {
  //     return `${this.whiteLabelledUrl}#!/e/commercialcriteria`;
  //   }
  // }

  // generateDevFinanceCriteriaURL(): string {
  //   if (this.selectedOrganisation.organisationCode) {
  //     return `${this.whiteLabelledUrl}${this.selectedOrganisation.organisationCode}#!/e/devfinancecriteria`;
  //   } else if (this.selectedOrganisation.isBrickflow) {
  //     return `${this.whiteLabelledUrl}#!/e/devfinancecriteria`;
  //   }
  // }

  // generateCriteriaUrl(linkType: LinkTypeEnum, id: number = null): string {
  //   var url = "";

  //   if (linkType == LinkTypeEnum.Bridging) {
  //     url = this.generateBridgingCriteriaURL();
  //   } else if (linkType == LinkTypeEnum.Commercial) {
  //     url = this.generateCommercialCriteriaURL();
  //   } else if (linkType == LinkTypeEnum.Development) {
  //     url = this.generateDevFinanceCriteriaURL();
  //   }

  //   if (id != null) {
  //     url += "/0/" + id;
  //   }

  //   return url;
  // }

  generateUniqueLinkCode(linkType: LinkTypeEnum, uniqueId: string = "", isWidgetLink: boolean = false) {
    if (this.selectedOrganisation.organisationCode) {
      this.message = `${this.whiteLabelledUrl}${this.selectedOrganisation.organisationCode}#!/enterprise/${uniqueId}`;
    } else if (this.selectedOrganisation.isBrickflow) {
      this.message = `${this.whiteLabelledUrl}#!/enterprise/${uniqueId}`;
    }

    if (isWidgetLink) {
      this.message += "/widget";
    }

    // if (
    //   (linkType == LinkTypeEnum.Bridging ||
    //     linkType == LinkTypeEnum.Commercial ||
    //     linkType == LinkTypeEnum.Development) &&
    //   !isWidgetLink
    // ) {
    //   this.message = this.generateCriteriaUrl(linkType, id);
    // } else {
    //   this.message = this.generateAllLoansUrl(id);

    //   if (isWidgetLink) {
    //     this.message += id != null ? "/widget" : "/0/widget";

    //     if (
    //       linkType == LinkTypeEnum.Bridging ||
    //       linkType == LinkTypeEnum.Commercial ||
    //       linkType == LinkTypeEnum.Development
    //     ) {
    //       this.message += `/${linkType}`;
    //     }
    //   }
    // }

    if (!isWidgetLink && (this.selectedOrganisation.organisationCode || this.selectedOrganisation.isBrickflow)) {
      this.messageTitle = "Please copy the below URL to include in your website.";
      this.widgetModal = true;
    } else if (isWidgetLink) {
      this.messageTitle = "Please copy the below widget URL.";
      this.widgetModal = true;
    } else {
      if (isWidgetLink) {
        this.deleteMessage =
          "To access URL please ensure company has an active White Label add-on and completed the URL Company Code in company settings (under White Label).";
      } else {
        this.deleteMessage =
          "To access your " +
          this.leadGeneratorName +
          " URL please ensure you have an active White Label add-on and you have completed the URL Company Code in your company settings (under White Label)";
      }
      this.messageDeleteModal = true;
    }
  }

  generateWidgetURL() {
    navigator.clipboard.writeText(`${location.origin}/${this.selectedOrganisation.organisationCode}#/initialregister`);
    this.message = "Widget url has been copied to the clipboard";
    this.widgetModal = true;
  }

  closeWidgetModal() {
    this.widgetModal = false;
    this.message = null;
    this.messageTitle = null;
  }

  copyButtonCodeToClipBoard() {
    navigator.clipboard.writeText(this.message);
    this.messageTitle = null;
    this.message = "Code has been copied to the clipboard";
  }

  bookCall() {
    window.open("https://brickflow.com/brokers/brickflow-enterprise/book-a-demo");
  }

  getLicenseStatusText() {
    this.allActiveAppPackagePrices = [];
    this.userClient.getLicenseStatusText(this.organisationAdmin.userName).then((response) => {
      this.licenseStatusText = response;
    });
  }

  /*getWhiteLabelledUrl() {
    this.staticDataClient.getWhiteLabelledUrl().then((response) => {
      this.whiteLabelledUrl = response;
    });
  }

  getConnectNetworkOrgId() {
    this.staticDataClient.getConnectNetworkOrgId().then((response) => {
      this.connectNetworkOrgId = Number(response);
    });
  }*/

  getAppSettings() {
    this.staticDataClient.getAppSettingsForOrganisation().then((response) => {
      this.whiteLabelledUrl = response.whiteLabelledUrl;
      this.connectNetworkOrgId = Number(response.connectOrgId);
      this.accountManagersOptions = response.customerSuccessAccountManagers.split(",");
    });
  }

  sendTestEmail(): void {
    this.organisationClient
      .sendTestEmail(this.testEmails, this.testEmailSubject, this.testEmailBody, this.selectedOrganisation.id)
      .then((response: boolean) => {
        if (response) {
          this.showTestEmailModal = false;
          this.showTestEmailSentConfirmation = true;
        } else {
          this.error = true;
        }
      })
      .catch((response) => {
        this.error = true;
      });
  }

  closeTestEmailConfirmation() {
    this.showTestEmailSentConfirmation = false;
    this.testEmails = null;
  }

  validateComanyCode() {
    this.validateCodeClicked = true;
    if (/^[A-Za-z0-9]*$/.test(this.selectedOrganisation.organisationCode)) {
      this.organisationClient
        .isOrganisationCodeValid(this.selectedOrganisation.id, this.selectedOrganisation.organisationCode)
        .then((response: boolean) => {
          if (response) {
            this.isValidOrgCode = true;
          } else {
            this.isValidOrgCode = false;
          }
        });
    } else {
      this.isValidOrgCode = false;
    }
  }

  fetchUniqueLinks() {
    this.fetchingUniqueLinks = true;
    this.organisationClient
      .getUniqueLinks(this.selectedOrganisation.id)
      .then((response) => {
        this.uniqueLinks = response;
      })
      .finally(() => {
        this.fetchingUniqueLinks = false;
      });
  }

  selectUniqueLink(uniqueLink?: OrganisationLink) {
    if (uniqueLink) {
      this.selectedUniqueLink = { ...uniqueLink };
      this.initselectedUniqueLinkType();
      this.isEditUniqueLink = true;
    } else {
      this.linkTypeSelection = {};
      this.selectedUniqueLink = {} as OrganisationLink;
      this.selectedUniqueLink.organisation = null;
      this.selectedUniqueLink.logoUrl = "";
      this.selectedUniqueLink.linkDescription = "";
      this.selectedUniqueLink.brokerUser = null;
      this.selectedUniqueLink.organisationId = this.selectedOrganisation.id;
      this.isEditUniqueLink = false;
    }
    this.showEditUniqueLinkModal = true;
  }

  onClickOfDeleteUniqueLink(uniqueLink: OrganisationLink) {
    this.selectedUniqueLink = uniqueLink;
    if (this.isAdmin && !this.organisationAdmin) {
      this.displayMessage = `Please assign a new Org User before deleting ${this.selectedUniqueLink.linkName}.`;
    } else {
      this.displayMessage = `Are you sure you wish to remove ${this.selectedUniqueLink.linkName}?`;
      this.deleteUniqueLinkClicked = true;
    }
    this.confirmUniqueLinkDeletion = true;
  }

  getLinkType(linkTypeEnum: LinkTypeEnum) {
    if (linkTypeEnum == LinkTypeEnum.Development) return "Development";
    if (linkTypeEnum == LinkTypeEnum.Bridging) return "Bridging";
    if (linkTypeEnum == LinkTypeEnum.AllLoans) return "All Loans";
    if (linkTypeEnum == LinkTypeEnum.Commercial) return "Commercial";
    return "Custom";
  }

  getLinkDescription(linkDescription) {
    return linkDescription === null ? "" : linkDescription;
  }

  removeUniqueLinkLogo() {
    this.selectedUniqueLink.logoUrl = null;
  }

  onFileSelect(files) {
    if (files.length > 0) {
      this.imageErrorMsg = null;
      const allowedExtensions = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tif",
        "tiff",
        "ico",
        "jfif",
        "pjpeg",
        "pjp",
        "apng",
      ];
      const filteredFiles = files.filter((file) => {
        const fileExtension = file.name.split(".").pop()?.toLowerCase();
        return fileExtension && allowedExtensions.indexOf(fileExtension) !== -1;
      });

      if (filteredFiles.length === 0) {
        this.imageErrorMsg = "Invalid file type: SVG and webp formats are not supported";
        return;
      }

      this.fileAttachmentHelper
        .uploadPublicImage(files, this.selectedOrganisation.organisationCode)
        .then((imageUrl) => {
          this.selectedUniqueLink.logoUrl = imageUrl;
          this.editLogo = true;
        });
    }
  }

  isUniqueLinkEmpty() {
    return this.isNullOrWhitespace(this.selectedUniqueLink.linkName) || this.selectedUniqueLink.linkType == null;
  }

  isNullOrWhitespace(input) {
    return !input || !input.trim();
  }

  saveUniqueLink() {
    this.isSavingUniqueLink = true;
    this.organisationLinkClient
      .addUpdateCustom(this.selectedUniqueLink)
      .then((response) => {
        if (response) {
          this.isSavingUniqueLink = false;
          this.isEditUniqueLink = false;
          this.showEditUniqueLinkModal = false;
        } else {
          this.ulsavemessage = `There is problem saving ${this.selectedUniqueLink.linkName} details, Please try later.`;
        }
        this.fetchUniqueLinks();
      })
      .catch((error) => {
        this.isSavingUniqueLink = false;
        this.ulsavemessage = "There is a problem. Please try later.";
        console.error("Error saving unique link:", error);
      });
  }

  deleteUniqueLink() {
    if (this.deleteUniqueLinkClicked) {
      this.isEditUniqueLink = true;
      this.selectedUniqueLink.isDeleted = true;
      this.selectedUniqueLink.isEnabled = false;
      this.organisationLinkClient.markAsDeleted(this.selectedUniqueLink.id).then(() => {
        this.fetchUniqueLinks();
        this.isEditUniqueLink = false;
        this.confirmUniqueLinkDeletion = false;
        this.deleteUniqueLinkClicked = false;
      });
    } else {
      this.confirmUniqueLinkDeletion = false;
    }
  }

  cancelUniqueLinkModal() {
    this.selectedUniqueLink = undefined;
    this.showEditUniqueLinkModal = false;
    this.error = false;
  }

  closeUniqueLinkDeleteModal() {
    this.confirmUniqueLinkDeletion = false;
    this.deleteUniqueLinkClicked = false;
    this.ulsavemessage = "";
  }

  validateKey() {
    this.hubspotMessage = null;
    this.missingProperties = null;
    this.organisationClient
      .validateKey(this.selectedOrganisation.hubspotAccessToken, this.selectedOrganisation.hubspotPipelineStage)
      .then((response) => {
        this.isHubspotValid = response == "Access token is valid.";
        this.hubspotMessage = response;
      })
      .then(() => {
        if (this.isHubspotValid) {
          this.organisationClient
            .getMissingProperties(
              this.selectedOrganisation.hubspotAccessToken,
              this.selectedOrganisation.hubspotPipelineStage,
            )
            .then((missingProperties) => {
              this.missingProperties = missingProperties;
            })
            .catch((error) => {
              this.hubspotMessage = `Error fetching missing properties: ${error.message}`;
            });
        } else {
          this.missingProperties = null;
        }
      });
  }

  setDefaultOrganisationThemeColour() {
    this.selectedOrganisation.organisationThemeColour = "#304B9A";
    this.registrationForm.$setDirty();
  }

  closeOtherLinkDropDown(linkType) {
    if (linkType != LinkTypeEnum.Development) {
      this.showDevFinanaceLinkOptions = false;
    }

    if (linkType != LinkTypeEnum.Bridging) {
      this.showBridgingLinkOptions = false;
    }
    if (linkType != LinkTypeEnum.Commercial) {
      this.showCommercialLinkOptions = false;
    }
    if (linkType != LinkTypeEnum.AllLoans) {
      this.showAllLoansLinkOptions = false;
    }
  }

  closeUniqueLinkGenerateDropdown(row) {
    if (this.showLinkOptions) {
      this.showLinkOptions[row] = false;
    }
  }

  closeAllEnterpriseLinkDropdowns() {
    this.showDevFinanaceLinkOptions = false;
    this.showBridgingLinkOptions = false;
    this.showCommercialLinkOptions = false;
    this.showAllLoansLinkOptions = false;
  }

  initializeSelectedNetworks() {
    if (this.selectedOrganisation.brokerNetworks) {
      this.selectedBrokerNetworks = this.selectListService.decodeBitwiseEnum(
        this.selectedOrganisation.brokerNetworks,
        this.selectListService.GetBrokerNetworks(),
      );
    } else {
      this.selectedBrokerNetworks = [];
    }

    this.brokerNetworks.forEach((item) => {
      (item as any).ticked = false;

      this.selectedBrokerNetworks.forEach((br: ListItem) => {
        if (br.key == item.key) {
          (item as any).ticked = true;
        }
      });
    });
  }

  initializeCRMs() {
    if (this.selectedOrganisation.crMs) {
      this.selectedCRMs = this.selectListService.decodeBitwiseEnum(
        this.selectedOrganisation.crMs,
        this.selectListService.GetCRMs(),
      );
    } else {
      this.selectedCRMs = [];
    }

    this.crms.forEach((item) => {
      (item as any).ticked = false;

      this.selectedCRMs.forEach((crm: ListItem) => {
        if (crm.key == item.key) {
          (item as any).ticked = true;
        }
      });
    });
  }

  hasOtherCrmSelected(): boolean {
    // Prefer key check (safer than label text)
    return this.selectedCRMs?.some(x => x.key === CRMEnum.Other)
      // fallback if enum not in scope:
      || this.selectedCRMs?.some(x => (x.displayName || '').toLowerCase() === 'other') || false;
  }

  saveSelectedNetworks() {
    this.selectedOrganisation.brokerNetworks = this.selectListService.encodeBitwiseEnum(this.selectedBrokerNetworks);
    this.registrationForm.$setDirty();
  }

  saveSelectedCRMs() {
    this.selectedOrganisation.crMs = this.selectListService.encodeBitwiseEnum(this.selectedCRMs);
    this.registrationForm.$setDirty();
  }

  isConnectMemberChanged() {
    this.showMarkAsConnectConfirmationModal =
      this.selectedOrganisation.isConnectMember &&
      this.originalOrganisation &&
      !this.originalOrganisation.isConnectMember;
  }

  OnCancelMarkAsConnect() {
    this.selectedOrganisation.isConnectMember = false;
    this.isProcessingOrgSave = false;
    this.showMarkAsConnectConfirmationModal = false;
  }

  OnConfirmMarkAsConnect() {
    if (this.isProcessingOrgSave) {
      this.isMarkAsConnectConfirmed = true;
      this.showMarkAsConnectConfirmationModal = false;
      this.saveOrganisation();
    } else {
      this.showMarkAsConnectConfirmationModal = false;
    }
  }

  updateSelectedLinkTypes(item: LinkTypeEnum): void {
    const isAll = item === LinkTypeEnum.AllLoans;

    // Initialize selectedLinkTypes if needed
    this.selectedUniqueLink.linkType = this.selectedUniqueLink.linkType || null;

    // Handle 'AllLoans' checkbox separately
    if (isAll) {
      const isAllChecked = this.linkTypeSelection[LinkTypeEnum.AllLoans];

      if (isAllChecked) {
        // Uncheck all other types
        Object.keys(this.linkTypeSelection).forEach((k) => {
          const key = Number(k);
          if (key !== LinkTypeEnum.AllLoans) {
            this.linkTypeSelection[key] = false;
          }
        });

        this.selectedUniqueLink.linkType = LinkTypeEnum.AllLoans;
      } else {
        this.selectedUniqueLink.linkType &= ~LinkTypeEnum.AllLoans;
      }

      return;
    }

    const isChecked = this.linkTypeSelection[item];

    // If AllLoans is checked, uncheck it first
    if (this.linkTypeSelection[LinkTypeEnum.AllLoans]) {
      this.linkTypeSelection[LinkTypeEnum.AllLoans] = false;
      this.selectedUniqueLink.linkType &= ~LinkTypeEnum.AllLoans;
    }

    if (isChecked) {
      this.selectedUniqueLink.linkType |= item; // Add item
    } else {
      this.selectedUniqueLink.linkType &= ~item; // Remove item
    }
  }

  initselectedUniqueLinkType() {
    this.linkTypeSelection = {};

    const linkType = this.selectedUniqueLink?.linkType ?? null;

    if (!linkType) return;

    // Dynamically extract all numeric enum values (excluding combined values like 7)
    const enumValues = Object.values(LinkTypeEnum)
      .filter((value) => typeof value === "number")
      .filter((value) => value !== LinkTypeEnum.AllLoans); // skip 'All' unless you want to handle it separately

    if (linkType === LinkTypeEnum.AllLoans) {
      this.linkTypeSelection[LinkTypeEnum.AllLoans] = true;

      // Set all other checkboxes false
      enumValues.forEach((value) => {
        this.linkTypeSelection[value] = false;
      });
    } else {
      this.linkTypeSelection[LinkTypeEnum.AllLoans] = false;

      enumValues.forEach((value) => {
        this.linkTypeSelection[value] = !!(linkType & value);
      });
    }
  }
}
